<template>
  <div class="oai-IntervalStep">
    <OnboardingAiStepHeader
      :subtitle="$t('onboarding.ai.interval.subtitle')"
      :wizard-step="wizardStep"
      title-key-path="onboarding.ai.interval.title_prefix"
      title-key-name="toStartWith"
      :title-key-accent="$t('onboarding.ai.interval.title_accent')"
    />

    <div class="oai-IntervalStep_Options">
      <OnboardingAiIntervalOptionCard
        v-for="option in intervalOptions"
        :key="option.id"
        v-model="selectedIntervalId"
        :name="INTERVAL_RADIO_GROUP_NAME"
        :option="option"
        :value="option.id"
      />
    </div>

    <OnboardingAiStepActions :disable="!canProceed" @next="onNext" />
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'

import { useOnboardingAiTracking } from '@/composables/onboarding-ai-step'
import { EVENT_NAMES } from '@/tracking/amplitude-helpers'
import {
  getDefaultOnboardingAiIntervalId,
  getOnboardingAiIntervalOptions
} from '@/utils/onboarding-ai/interval-options'

import OnboardingAiIntervalOptionCard from '@/components/ui/onboarding-ai/OnboardingAiIntervalOptionCard'
import OnboardingAiStepActions from '@/components/ui/onboarding-ai/OnboardingAiStepActions'
import OnboardingAiStepHeader from '@/components/ui/onboarding-ai/OnboardingAiStepHeader'

defineOptions({
  name: 'OnboardingAiOkrIntervalStep'
})

const { logEvent } = useOnboardingAiTracking()

const INTERVAL_RADIO_GROUP_NAME = 'onboarding-ai-interval'

defineProps({
  wizardStep: {
    type: Number,
    required: true
  },

  modelValue: {
    type: String,
    default: () => getDefaultOnboardingAiIntervalId()
  }
})

const emit = defineEmits({
  next: null
})

const intervalOptions = computed(() => getOnboardingAiIntervalOptions())

const selectedIntervalId = defineModel({ type: String })

const canProceed = computed(() => Boolean(selectedIntervalId.value))

const onNext = () => {
  emit('next', {
    interval_option: selectedIntervalId.value
  })
}

onMounted(() => {
  logEvent(EVENT_NAMES.ONBOARDING_OKR_INTERVAL_VIEWED)
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/onboarding-ai-step';

.oai-IntervalStep {
  @extend %oai-wizard-step-shell;
}

.oai-IntervalStep_Options {
  display: grid;
  gap: 12px;
  width: 100%;
}
</style>
